var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendingFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 7,
    viewBox: "0 0 15 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6.54131L10.729 5.77131L12.625 3.87531H0.208008V2.79131H12.625L10.729 0.895305L11.5 0.125305L14.708 3.33331L11.5 6.54131Z",
    fill: "#51606F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingFlat);
export default __webpack_public_path__ + "static/media/trending_flat.95ebfb94beead0833f22ccdad5eb7a2f.svg";
export { ForwardRef as ReactComponent };